export const UserCRMDetailSegments = (props: any) => {
  return <>People Segments</>
}
